module.exports = __webpack_public_path__ + "media/images/solicitud/afiliado-447a39260335dc084e1e759189982f44.svg";